// Module
var code = "<div ng-if=\"$ctrl.procedure\"> <procedure-editor procedure=\"$ctrl.procedure\" editor-mode=\"$ctrl.editorMode\"> </procedure-editor> </div> <error-message ng-if=\"$ctrl.deniedAccess\" message=\"'You are not authorized to view this SOP'\"></error-message> ";
// Exports
export default code;